<template>
  <div class="ProdImg-container">
    <div class="gb-wrap">
      <div class="my-title">
        <div class="my-title-cn">产品图片</div>
        <p class="my-title-en">PRODUCT IMAGE</p>
      </div>
      <div class="my-cont clearfix">
        <div class="my-left">
          <ul class="my-list">
            <li
              v-for="(item, index) in items"
              :class="{
                'my-active': selectedIdx === index,
                invisible: !item.visible,
                animated: item.visible,
                flipInY: item.visible
              }"
              :style="{ 'animation-delay': 0.1 * index + 's' }"
              :key="index"
              js-ani-target
              @mouseover="selectedIdx = index"
            >
              <i class="my-tick">▲</i>
              {{ item.title }}
            </li>
          </ul>
        </div>
        <div class="my-right">
          <div class="my-imgs">
            <img v-for="(item, index) in items" :class="{ 'my-active': selectedIdx === index }" :src="item.img" alt :key="index" width="600px" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProdImg',
  data() {
    return {
      items: [
        {
          title: '创作页',
          subtitle: 'Home',
          img: require('@/assets/prod_img_home.png')
        },
        {
          title: '数据库',
          subtitle: 'Story line',
          img: require('@/assets/prod_img_data.png')
        },
        {
          title: '逻辑编辑',
          subtitle: 'Engine',
          img: require('@/assets/prod_img_edit.png')
        },
        {
          title: '美术素材',
          subtitle: 'Details',
          img: require('@/assets/prod_img_material.png')
        },
        {
          title: '音乐素材',
          subtitle: 'Comment',
          img: require('@/assets/prod_img_music.png')
        }
      ].map(d =>
        Object.assign(d, {
          visible: false
        })
      ),
      selectedIdx: 0
    }
  },
  created() {
    window.addEventListener('scroll', this.scrollListener)
  },
  beforeDestroy() {
    this.removeListener()
  },
  methods: {
    removeListener() {
      window.removeEventListener('scroll', this.scrollListener)
    },
    scrollListener() {
      let flag = true
      let arr = Array.from(this.$el.querySelectorAll('[js-ani-target]'))
      if (arr.length > 0) {
        arr.forEach((d, i) => {
          let item = this.items[i]
          if (this.$utils.isInViewPort(d)) {
            d.classList.add('animated', 'flipInY')
            item.visible = true
          }
          flag = flag && item.visible
        })
        if (flag) this.removeListener()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ProdImg-container {
  overflow: hidden;
}

.my-title {
  padding-top: 95px;
  padding-bottom: 30px;
}

.my-title-cn {
  font-size: 40px;
  color: #333333;
  line-height: 70px;
}

.my-title-en {
  margin-top: 10px;
  font-size: 22px;
  color: rgba(#58627c, 0.5);
}

.my-cont {
  padding-bottom: 150px;
  width: 1200px;
  display: flex;
  justify-content: space-between;
}

.my-left {
  // float: left;
  width: 600px;
}

.my-list {
  padding-left: 110px;
  padding-top: 135px;
  li {
    padding: 25px 0;
    width: fit-content;
    font-size: 30px;
    color: #666666;
    cursor: default;
    &.my-active {
      color: #4b85ff;
    }
  }
}

.my-tick {
  display: none;
  transform: rotate(90deg);
  li.my-active & {
    display: inline-block;
  }
}

.my-right {
  // float: right;
  width: 100%;
  justify-items: end;
}

.my-imgs {
  position: relative;
  // width: 341px;
  // height: 674px;
  img {
    position: absolute;
    // left: -90px;
    right: 0;
    top: 140px;
    // width: 100%;
    opacity: 0;
    transition: all 1s;
    &.my-active {
      opacity: 1;
      z-index: 9;
    }
  }
}
</style>
